/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lush_Wide_Frog_BiteInputs */

const en_lush_wide_frog_bite = /** @type {(inputs: Lush_Wide_Frog_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reactivating survey token...`)
};

const de_lush_wide_frog_bite = /** @type {(inputs: Lush_Wide_Frog_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token wird reaktiviert...`)
};

/**
* | output |
* | --- |
* | "Reactivating survey token..." |
*
* @param {Lush_Wide_Frog_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lush_wide_frog_bite = /** @type {((inputs?: Lush_Wide_Frog_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lush_Wide_Frog_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lush_wide_frog_bite(inputs)
	return de_lush_wide_frog_bite(inputs)
});